import { type RefObject, useEffect } from 'react';
import type { ScrollView } from 'react-native';

const SCROLL_TO_END_DELAY = 150;

export default function useScrollToEnd(
  ref: RefObject<ScrollView | null>,
  shouldScroll: boolean,
  effect: unknown,
) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: effect arg changes should retrigger this
  useEffect(() => {
    if (!shouldScroll) {
      return;
    }

    const timeoutId = setTimeout(() => {
      ref.current?.scrollToEnd();
    }, SCROLL_TO_END_DELAY);

    return () => clearTimeout(timeoutId);
  }, [ref, shouldScroll, effect]);
}
